import { render } from "./BookWorkersTable.vue?vue&type=template&id=65a67adb&ts=true"
import script from "./BookWorkersTable.vue?vue&type=script&lang=ts"
export * from "./BookWorkersTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__